import { SrInsightType as InsightType } from '@plato/data/starrocks/types';
import type { Namespace, TFunction } from 'i18next';
import type { InsightDTO, ResolvedOutcomeInsightDTO } from '../../../server/dto/insight-dto.ts';
import { churnV2CardDimension } from '../components/churn-v2-dimension.ts';

export function getInsightName(
    t: TFunction<Namespace>,
    insight: InsightDTO | ResolvedOutcomeInsightDTO,
): string {
    if (insight.insight_type === InsightType.INDUSTRY_TOP) {
        return t(`insight_name__${insight.insight_type}`, {
            ns: 'insights',
            industry_sector: insight.template_arguments?.industry_sector,
        });
    }

    if (insight.insight_type === InsightType.CHURN_WARNING) {
        const args = insight.template_arguments;
        // Only v2 churn carries dimensions; v1 and resolved outcomes get the generic name.
        // Same selector as the tooltip and body text, so the heading cannot contradict them.
        const dim = args && 'top_dimension_1' in args ? churnV2CardDimension(args) : undefined;
        const options = { ns: 'insights' } as const;

        switch (dim) {
            case 'd1_silence':
                return t('churn_v2_title__d1_silence', options);
            case 'd2_cadence':
                return t('churn_v2_title__d2_cadence', options);
            case 'd3_annual':
                return t('churn_v2_title__d3_annual', options);
            case 'd4_seasonal':
                return t('churn_v2_title__d4_seasonal', options);
            case 'd5_revenue':
                return t('churn_v2_title__d5_revenue', options);
            case 'd6_momentum':
                return t('churn_v2_title__d6_momentum', options);
            case 'd7_concentration':
                return t('churn_v2_title__d7_concentration', options);
            case 'd8_global':
                return t('churn_v2_title__d8_global', options);
            case undefined:
                return t(`insight_name__${InsightType.CHURN_WARNING}`, options);
        }
    }

    return t(`insight_name__${insight.insight_type}`, {
        ns: 'insights',
    });
}
